import { create } from "zustand";
import { Profile } from "../Models/Profile";
import { addFilesToExpo, createExpo, deleteExpo, getAllExpos, getExpo, removeExpoFile, updateExpo } from "../repositories/ExpoRepository";
import { Expo } from "../Models/Expo";
import { ExpoDto } from "../Models/ExpoDto";

export interface ExpoStore {
  fetchAllExpos: () => Promise<Expo[] | undefined>;
  fetchExpo: (user: Profile, expoId: number) => Promise<Expo | undefined>;
  addExpo: (user: Profile, expo: ExpoDto) => Promise<number | undefined>;
  editExpo: (
    user: Profile,
    expo: Partial<ExpoDto>,
    expoId: number
  ) => Promise<number | undefined>;
  removeExpo: (
    user: Profile,
    expoId: number
  ) => Promise<number | undefined>;
  addExpoFiles: (user: Profile, expoId: number, files: File[]) => Promise<number>;
  removeExpoFile: (user: Profile, expoId: number, fileId: number) => Promise<number>;
}

export const useExpo = create<ExpoStore>(() => ({
  fetchAllExpos: () => {
    return getAllExpos();
  },

  fetchExpo: (user, expoId) => {
    return getExpo(user, expoId);
  },

  addExpo: (user, expo) => {
    return createExpo(user, expo);
  },

  editExpo: (user, expo, expoId) => {
    return updateExpo(user, expo, expoId);
  },

  removeExpo: (user, expoId) => {
    return deleteExpo(user, expoId);
  },

  addExpoFiles: (user, expoId, files) => {
    return addFilesToExpo(user, expoId, files);
  },

  removeExpoFile: (user, expoId, fileId) => {
    return removeExpoFile(user, expoId, fileId);
  },
}));
